var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('sub-navigation-bar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }